import styles from './ProvisionalFileView.module.scss';

const ProvisionalFileStatusNote = ({ message }: { message: string }) => <p className={styles.StatusNote}>{message}</p>;

export default ProvisionalFileStatusNote;
